module.exports = "/_next/static/images/hero-nyc-d608d699e13fe8a80c2d304041ed6c38.webp";